module.exports = __webpack_public_path__ + "img/go.af6f7f4a.png";